import { render } from "./bulkSupplierZFReportList.vue?vue&type=template&id=21418104&scoped=true"
import script from "./bulkSupplierZFReportList.vue?vue&type=script&lang=js"
export * from "./bulkSupplierZFReportList.vue?vue&type=script&lang=js"

import "./bulkSupplierZFReportList.vue?vue&type=style&index=0&id=21418104&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21418104"]])

export default __exports__